import React from 'react';
import { useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
//import { ReactComponent as PauseIcon } from '../../../../public/icons/AudioTag/pause_circle.svg';
import Pause from "../../../shared/Svg/Pause";
import PlayButton from "../../../shared/Svg/PlayButton";
import defaultAlbumImg from '../../../../public/images/default-alblum-img.png';
import hv_player_api from '../../../../api/hv_player_api';

const AudioControl = (props) => {
  const { medium, source } = props;
  const { currently_playing, playing } = useSelector((state) => state);
  const isBeingPlayed = currently_playing && currently_playing.id === medium.id;
  const playMedium = () =>
    source
      ? source.type === 'queue'
        ? hv_player_api.playMediaFromQueue(medium)
        : hv_player_api.playMediaWithSource(medium, source)
      : hv_player_api.playMediaWithoutSource(medium);

  const stopPropagation = (e) => {
    e.stopPropagation();
  };
  return (
    <div className="audio-controls">
      <div className="preview-img">
        <img
          src={
            medium.preview_image ? medium.preview_image.url : defaultAlbumImg
          }
          alt="ALBUM-THUMBNAIL"
        />
      </div>
      <div className="controls" onClick={stopPropagation}>
        {isBeingPlayed ? (
          currently_playing.status === 'ready' ? (
            playing ? (
              /*
              <PauseIcon
                className="pause-button"
                onClick={hv_player_api.pause}
              />*/
              <Pause className="pause-button" onClick={hv_player_api.pause} />
            ) : (
              <PlayButton className="play-button" onClick={hv_player_api.play} />
            )
          ) : (
            <Spinner
              animation="border"
              variant="primary"
              size="sm"
              role="status"
              style={{ width: '20px', height: '20px' }}
            />
          )
        ) : (
          <PlayButton className="play-button" onClick={playMedium} />
        )}
      </div>
    </div>
  );
};
export default AudioControl;
